export default (props) => (
    /**
   * Icone de uma seta apontando para sudoeste com um quadrado faltando um pedaço
   * responsavel por importar projetos no formato(.gba).
   * Encontrado no menu de ferramentas.
  */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.33688 10.8326C8.06561 11.1038 7.52912 11.0071 7.1386 10.6166C6.74807 10.2261 6.65139 9.68961 6.92266 9.41834L13.1743 3.16675C13.4455 2.89548 13.982 2.99216 14.3725 3.38268C14.7631 3.77321 14.8597 4.3097 14.5885 4.58096L8.33688 10.8326Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M7.93994 9.81494L11.9399 9.81494C12.4922 9.81494 12.9399 10.2627 12.9399 10.8149C12.9399 11.3672 12.4922 11.8149 11.9399 11.8149L6.93994 11.8149C6.38766 11.8149 5.93994 11.3672 5.93994 10.8149L5.93994 5.81494C5.93994 5.26266 6.38766 4.81494 6.93994 4.81494C7.49223 4.81494 7.93994 5.26266 7.93994 5.81494L7.93994 9.81494Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M15.0273 9.46094C15.0273 8.90865 15.4751 8.46094 16.0273 8.46094C16.5796 8.46094 17.0273 8.90865 17.0273 9.46094V15.0859C17.0273 16.6738 15.7402 17.9609 14.1523 17.9609H2.90234C1.31452 17.9609 0.0273438 16.6738 0.0273438 15.0859L0.0273461 3.83593C0.0273461 2.24812 1.31453 0.960938 2.90234 0.960938C6.93429 0.960941 6.93428 0.960941 8.9961 0.960941C9.54838 0.960941 9.9961 1.40866 9.9961 1.96094C9.9961 2.51323 9.54838 2.96094 8.9961 2.96094C6.93428 2.96094 6.93428 2.96094 2.90234 2.96094C2.41909 2.96094 2.02735 3.35269 2.02735 3.83593L2.02734 15.0859C2.02734 15.5692 2.41909 15.9609 2.90234 15.9609H14.1523C14.6356 15.9609 15.0273 15.5692 15.0273 15.0859V9.46094Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
